module.exports = __webpack_public_path__ + "img/email.b4a4683e.svg";